export default function Fechamento() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511985111042?text=Olá! Gostaria de falar com um especialista.', '_blank');
  };

  return (
    <>
      <section className="py-16 md:py-24 bg-gradient-to-br from-emerald-600 to-emerald-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Valorize seu espaço com quem entende de Realeza.
          </h2>
          
          <p className="text-base sm:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            Não deixe seu mobiliário nas mãos de amadores. Escolha a experiência, o design e a confiança de quem é autoridade no mercado paulistano há 35 anos.
          </p>

          <button
            onClick={handleWhatsAppClick}
            className="bg-white text-emerald-600 px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-semibold shadow-2xl hover:shadow-white/30 transition-all duration-300 hover:scale-105 whitespace-normal sm:whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-3"></i>
            Falar com um Especialista Agora
          </button>

          <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 text-white">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-map-pin-line text-3xl"></i>
              </div>
              <h3 className="font-semibold text-lg mb-2">Atendemos toda SP</h3>
              <p className="text-white/80 text-sm">Grande São Paulo e região</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-phone-line text-3xl"></i>
              </div>
              <h3 className="font-semibold text-lg mb-2">Consultoria Gratuita</h3>
              <p className="text-white/80 text-sm">Orçamento sem compromisso</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-calendar-check-line text-3xl"></i>
              </div>
              <h3 className="font-semibold text-lg mb-2">Prazos Garantidos</h3>
              <p className="text-white/80 text-sm">Cronograma transparente</p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção do Mapa — separada, fora do footer */}
      <section className="bg-stone-100 py-12">
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-shrink-0 flex flex-col gap-2">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-stone-800 font-semibold text-base mb-1">Nossa Localização</h4>
                  <p className="text-stone-600 text-sm leading-relaxed">
                    R. Antonina, 125 - Vale do Sol<br />
                    Jandira - SP, 06620-370<br />
                    Brasil
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full rounded-xl overflow-hidden shadow-md" style={{ height: '280px' }}>
              <iframe
                title="Localização Realeza Tapeçaria"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0!2d-46.9!3d-23.53!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sR.+Antonina%2C+125+-+Vale+do+Sol%2C+Jandira+-+SP%2C+06620-370!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr&q=R.+Antonina,+125,+Vale+do+Sol,+Jandira,+SP,+06620-370,+Brasil"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Rodapé limpo */}
      <footer className="bg-emerald-700 py-10 border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center">

            {/* Logo */}
            <div className="flex flex-col items-center md:items-start">
              <img 
                src="https://public.readdy.ai/ai/img_res/44ac6951-7957-465a-b660-4b544ef0dc70.png" 
                alt="Realeza Tapeçaria & Design"
                className="h-28 object-contain"
              />
              <p className="text-white/70 text-xs mt-3 text-center md:text-left">
                35 anos transformando ambientes em São Paulo
              </p>
            </div>

            {/* Contato */}
            <div className="flex flex-col items-center gap-3 text-center">
              <a
                href="https://wa.me/5511985111042"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/90 hover:text-white transition-colors cursor-pointer text-sm"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                (11) 98511-1042
              </a>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                Jandira - SP
              </div>
            </div>

            {/* Direitos */}
            <div className="flex flex-col items-center md:items-end gap-2">
              <p className="text-white/90 text-sm text-center md:text-right">
                © 2026 Realeza Tapeçaria & Design.<br />Todos os direitos reservados.
              </p>
              <p className="text-white/60 text-xs">
                Desenvolvido por{' '}
                <a
                  href="https://suritarafa.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-white transition-colors cursor-pointer"
                >
                  Suritarafa
                </a>
              </p>
            </div>

          </div>
        </div>
      </footer>
    </>
  );
}
